var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"height":"250px","overflow":"hidden"}},[(!_vm.emptyState)?_c('div',{ref:"charts",staticStyle:{"height":"100%"}}):_c('c-empty')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }